import axios from "axios";

export type DocumentType = "Web" | "PDF" | "Email" | "Excel" | "Phone" | "Fax";
export const DocumentTypes = ["Web", "PDF", "Email", "Excel", "Phone", "Fax"];

export default class Document {
  id: number | null = null;
  uuid: string | null = null;
  serial_no: string | null = null;
  confidential: boolean = false;
  name: string = "";
  type: DocumentType | null = null;
  publication_date: string | null = null;
  comment: string = "";
  url: string = "";
  original_filename: string = "";
  filename: string = "";
  content_type: string = "";
  displacement_types: string[] = [];
  countries: string[] = [];
  sources_old: string[] = [];
  publishers_old: string = "";
  created_by: string = "";
  created_at: string = "";
  updated_by: string = "";
  updated_at: string = "";
  gsn: string = "";
  sources: object[] = [];
  publishers: object[] = [];
}

export function getDocumentByID(id: number) {
  return axios.get(`/psql/documents`, {
    params: {
      id: `eq.${id}`,
      select: "*,facts(*)",
    },
    headers: { Accept: "application/vnd.pgrst.object+json" },
  });
}
